<template>
  <v-card
    class="card pa-16 d-flex flex-column align-center"
    color="gray10"
    flat
  >
    <v-icon size="94">$hourglass</v-icon>
    <p class="font-Bold-16 mt-4">
      {{
        $t("corporateAccount.manage.create.step3.legalAccountRequestSubmitted")
      }}
    </p>
    <p class="font-Regular-14 gray2--text text-center">
      {{ $t("corporateAccount.manage.create.step3.legalAccountNextSteps") }}
    </p>

    <v-btn
      to="/legal-entity/manage"
      x-large
      color="primary"
      class="mt-16 px-16"
    >
      {{ $t("corporateAccount.sidebar.legalAccountDashboard") }}
    </v-btn>
  </v-card>
</template>

<script>
export default {};
</script>
